<div id="world" class="viewport-1" [ngClass]="worldZoomClass" [style.background-image]="'url(' + worldViewImage + ')'">
  @if (animateActiveLocation) {
    <div class="viewport-1 full-fade-in" [style.background-image]="'url(' + worldViewLocationBackground + ')'"></div>
  }
  @for (overlayImage of overlayImages; track overlayImage) {
    <img class="viewport-1" [src]="overlayImage"/>
  }
  @if (displayCompletedMessage) {
    <congratulations></congratulations>
  }
</div>